// The landing page is served as static HTML from /public/index.html.
// React is still mounted (CRA pipeline) but renders nothing — the static
// HTML provides the entire experience.
function App() {
  return null;
}

export default App;
